export class EditReportDto {
    name!: string;
}